import React, { useState, useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Sidebar from './Sidebar';
import Header from './Header';
import MobileHeader from './MobileHeader';
import BottomTabBar from './BottomTabBar';
import { CommunityGuidelinesModal } from '../UI';
import { useAuthStore } from '../../store/authStore';
import { authApi } from '../../services/api';
import styles from './Layout.module.css';

const Layout: React.FC = () => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [showGuidelines, setShowGuidelines] = useState(false);
  const [acceptingGuidelines, setAcceptingGuidelines] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const { user, updateUser } = useAuthStore();

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    const hasAcceptedThisSession = sessionStorage.getItem('guidelines_accepted');
    if (user && !hasAcceptedThisSession) {
      setShowGuidelines(true);
    }
  }, [user]);

  const handleAcceptGuidelines = async () => {
    setAcceptingGuidelines(true);
    try {
      await authApi.acceptGuidelines();
      sessionStorage.setItem('guidelines_accepted', 'true');
      updateUser({ has_accepted_guidelines: true });
      setShowGuidelines(false);
    } catch (error) {
      console.error('Failed to accept guidelines:', error);
    } finally {
      setAcceptingGuidelines(false);
    }
  };

  if (isMobile) {
    return (
      <div className={styles.layout}>
        <MobileHeader />
        <main className={styles.mobileContent}>
          <Outlet />
        </main>
        <BottomTabBar />

        <CommunityGuidelinesModal
          isOpen={showGuidelines}
          onAccept={handleAcceptGuidelines}
          isLoading={acceptingGuidelines}
        />
      </div>
    );
  }

  return (
    <div className={styles.layout}>
      <Sidebar
        collapsed={sidebarCollapsed}
        onToggle={() => setSidebarCollapsed(!sidebarCollapsed)}
      />
      <div
        className={styles.mainContent}
        style={{ marginLeft: sidebarCollapsed ? '72px' : '240px' }}
      >
        <Header />
        <main className={styles.content}>
          <Outlet />
        </main>
      </div>

      <CommunityGuidelinesModal
        isOpen={showGuidelines}
        onAccept={handleAcceptGuidelines}
        isLoading={acceptingGuidelines}
      />
    </div>
  );
};

export default Layout;
